import { useEffect, useRef, useState } from 'react';

export const useValidationBlock = (
  isVisible: boolean,
  onValidationSuccess: () => void,
  onValidationFailure?: (val: string) => void,
) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isInvalid, setIsInvalid] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const nodeRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const input = inputRef.current;

    if (!input) {
      return undefined;
    }

    const handleInput = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const value = target.value.replace(/\D/g, '');
      target.value = value.slice(0, 1);
    };

    input.addEventListener('input', handleInput);

    return () => {
      input.removeEventListener('input', handleInput);
    };
  }, [isVisible]);

  const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (!!value && value !== '3') {
      setIsInvalid(true);

      if (onValidationFailure) onValidationFailure(value);
    }

    if (value === '3') {
      setIsComplete(true);
      onValidationSuccess();
    } else {
      setIsComplete(false);
    }
  };

  return {
    nodeRef,
    inputRef,
    isInvalid,
    onInput,
    isComplete,
  };
};
